import type { ApiHook } from 'utils/request/useApi';

export function unregisterExtension(
  extensionId: string,
  api: ApiHook,
): Promise<void> {
  return api.request({
    method: 'DELETE',
    url: `extensions/${extensionId}`,
  });
}
